import { ProviderConfig, ProviderTypes } from 'types';
import { UpdaterTheme } from 'config/themes';

export const Starry: ProviderConfig = {
  providerType: ProviderTypes.WISP,
  providerCode: 'starry',
  dcCode: 'Starry',
  name: 'Starry',
  displayName: 'Starry',
  reskinTheme: UpdaterTheme,
  reskinTitle: 'Starry Authorized Dealer',
  showPricingDisclaimer: false,
  broadbandDisplayType: 'updater_generated',
  disclaimerDisplaySettings: {
    showContractDisclaimer: false,
    showOfferDisclaimer: true,
    showPromotionsDisclaimer: false,
  },
};
